<template>
  <div style="display: inline-block">
    <button
    type="button"
    style="width:150px;"
    :disabled="isDisabled"
       class="btn btn-outline-secondary btn-export"
      @click="exportData()"
      value="Export to Excel">
      <span v-if="!isWorking">{{translate('excelExporter.exportToExcel')}}</span>
      <span v-else>
        <div class="spinner-border" role="status" style="height:18px; width:18px;">
          <span class="sr-only">{{translate('loading')}}</span>
        </div>
        {{translate('preparing')}}
      </span>
    </button>
    <list
      style="display: none"
      v-if="showExportTable"
      :table-id="tableId"
      @onload="onLoad"
      @onerror="onError"
      :exportOperation = "true"
      :recordPerPage="recordPerPage"
      :columns="columns"
      :url="url"
      :filter="filter"
      :listType="listType"
      :modelName="modelName"
      :predicate="predicate">
    </list>
  </div>
</template>
<script>
import list from "./List.vue";

export default { 
  components: {
    list,
  },
  data() {
    return {
      isWorking: false,
      isDisabled:false,
      showExportTable: false,
      errorMessage: null,
      page: 1,
      loading: false,
      data: {
        TotalRecordCount: 0,
        Result: [],
        Filter: {
          Skip: 0,
          Take: this.recordPerPage,
        },
      },
    };
  },
  props: {
    modelName: String, // Veri modelinin adı
    url: String, // Verinin çekileceği API url'i
    hideDetailsCommand: Boolean, // Detay butonunu gizle
    hideDeleteCommand: Boolean, //Sil buttonunu gizle
    columns: Array, // Sütunlar
    noDataText: String, // Veri bulunamadığında gösterilecek metin
    predicate: String, //
    orderBy: String, // Sıralama
    filter: Object, // Filtre nesnesi
    listType: String, //Liste tipi (örn: MyWaiting)
    recordPerPage: {
      type: Number,
      default() {
        return 999999;
      },
    },
  },
  computed: {
    tableId() {
      return "excel-export-" + this.modelName;
    },
  },
  methods: {
    exportData() {
      this.isWorking = true;
      this.isDisabled = true;
      this.showExportTable = true;
    },
    onLoad() {
      console.log("load event");
      var tableId = this.tableId;
      var routeName = this.$route.name;
      setTimeout(
        function (scope) {
          window.exportExcel(tableId, routeName);
          scope.showExportTable = false;
          scope.isDisabled = false;
          scope.isWorking = false;
          scope.$forceUpdate();
        },
        1000,
        this
      );
    },
    onError(err) {
      console.log("error event", err);
      alert(err);
    }
  }
};
</script>

<style scoped>
.btn-export {
  margin-left: 10px;
  margin-right: 10px;
}
fieldset {
  transition: opacity 0.15s ease-in-out;
}

fieldset.loading {
  opacity: 0.5;
}

select.page-item {
  text-align: right;
  width: 100px;
  height: calc(1.5em + 0.75rem + 2px);
  border-radius: 0;
  border-left: 0;
  border-right: 0;
}
</style> 